export default "__VITE_ASSET__Q5Vq0wya__"